<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'mes.production-notes.production-notes' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput (keyup)="applyFilter($event)" [placeholder]="'insights.administration.users.search' | translate" #input [cdkTrapFocusAutoCapture]="showSearch" [cdkTrapFocus]="showSearch" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
	</div>
</div>
<div class="flex flex-fill gap-horizontal-14">
	<mat-form-field appearance="outline">
		<mat-label>{{ 'mes.production-notes.shared.batch' | translate }}</mat-label>
		<mat-select [(ngModel)]="currentBatch" (selectionChange)="batchChange($event)" (keydown.enter)="searchByBatch()">
			@for (batch of batches; track batch) {
				<mat-option [value]="batch">
					{{ batch.alias }}
				</mat-option>
			}
		</mat-select>
	</mat-form-field>

	<button mat-flat-button color="primary" class="button-large" (click)="searchByBatch()">
		<mat-icon svgIcon="acies_search"></mat-icon>
	</button>

	<mat-form-field appearance="outline">
		<mat-label>{{ 'mes.production-notes.shared.order' | translate }}</mat-label>
		<input maxlength="255" matInput [(ngModel)]="order" (keydown.enter)="searchByOrderPosition()" />
	</mat-form-field>

	<mat-form-field appearance="outline">
		<mat-label>{{ 'mes.production-notes.shared.position' | translate }}</mat-label>
		<input maxlength="255" type="number" matInput [(ngModel)]="position" (keydown.enter)="searchByOrderPosition()" />
	</mat-form-field>

	<button mat-flat-button color="primary" class="button-large" (click)="searchByOrderPosition()">
		<mat-icon svgIcon="acies_search"></mat-icon>
	</button>
</div>

<div class="table-wrapper">
	<table class="table-responsive outer-table" mat-table [dataSource]="dataSource" matSort (matSortChange)="onSort($event)" multiTemplateDataRows>
		<ng-container matColumnDef="batch">
			<th class="prevent-select" mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.production-notes.shared.batch' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.batch }}</td>
		</ng-container>
		"
		<ng-container matColumnDef="order">
			<th class="prevent-select" mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.production-notes.shared.order' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.order }}</td>
		</ng-container>
		<ng-container matColumnDef="position">
			<th class="prevent-select" mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.production-notes.shared.position' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.position }}</td>
		</ng-container>

		<ng-container matColumnDef="expandedDetail">
			<td mat-cell *matCellDef="let item" [attr.colspan]="displayedColumns.length">
				<div class="element-detail" [@detailExpand]="expandedElements.includes(item) ? 'expanded' : 'collapsed'">
					@if (expandedElements.includes(item)) {
						<app-reorder-production-note-list [alias]="item.order + ':' + item.position" />
					}
				</div>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr class="order-position-row" mat-row *matRowDef="let element; columns: displayedColumns" [class.order-position-expandable]="element.notes.data?.length" [class.order-position-collapsed]="!expandedElements.includes(element)" (click)="toggleRow(element)"></tr>
		<tr class="order-position-detail-row" mat-row *matRowDef="let row; columns: ['expandedDetail']"></tr>
	</table>
</div>

<mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000]" [pageSize]="1000" showFirstLastButtons></mat-paginator>
